import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9rm92yvm: FaireBrandEntity = {
  token: "b_9rm92yvm",
  type: "brand",
  name: "White Rock Soap Gallery",
  avatarUrl:
    "https://cdn.faire.com/fastly/24ebec4b0495a10ef8f24a7f3ee16474dc9baeabc91ddecc840173abdeffc3ff.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/de792992ee5c5c099edd828c3acfd04d066039fdd0be53c69cb1f8d2f9e12923.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/24ebec4b0495a10ef8f24a7f3ee16474dc9baeabc91ddecc840173abdeffc3ff.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/de792992ee5c5c099edd828c3acfd04d066039fdd0be53c69cb1f8d2f9e12923.jpeg",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 225,
  isTopShop: true,
  isInsider: true,
  description:
    "It all started with a book on soap making purchased as a gift for Christmas of 2013. This began an experimental learning process with soap recipes followed by soy candles and vegan body care items. After a year and a half of doing local markets, we secured a production and retail facility that allowed us to move the business out of our kitchen. The word Gallery was included in our name so that we could spotlight other natural soap and body care makers. Our stores currently carry products from more the 50 Texas makers . We opened two more brick and mortar stores in the Bishop Arts and McKinney, Texas area the following year and our fourth location is scheduled to open at Grandscape in March 2020. \n\nOur core value from the start has been to craft healthy products using simple and safe ingredients. We decided that anything we made under the White Rock Soap Gallery brand that touched the body had to be 100% vegan and all-natural. We never use artificial fragrances, preservatives, colors, or synthetic chemicals in any of our handcrafted WRSG body care or soap products.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:06.637Z",
    importedBy: "entity-db-cli",
  },
};
